<template>
  <v-form
    ref="userForm"
    v-model="valid"
  >
    <v-layout
      style="width: 100%"
      wrap
      pb-2
    >
      <v-flex
        xs12
        pl-2
      >
        <v-layout
          class="field-padding"
          wrap
        >
          <v-flex
            xs6
            md4
            px-2
          >
            <label class="cmr-label-text">Full Name (*)</label>
            <v-text-field
              v-model="user.name"
              :error-messages="errorForField('name')"
              :rules="userRules.name"
              outlined
              dense
              @input="resetError('name')"
            />
          </v-flex>
          <v-flex
            xs6
            md4
            px-2
          >
            <label class="cmr-label-text">Mobile Number (*)</label>
            <v-text-field
              v-model="user.contact_number"
              dense
              outlined
              :error-messages="errorForField('contact_number')"
              :rules="userRules.contact_number"
              type="number"
              class="noStepNumber"
              @input="resetError('contact_number')"
            />
          </v-flex>
          <v-flex
            xs6
            md4
            px-2
          >
            <label class="cmr-label-text">Email (*)</label>
            <v-text-field
              v-model="user.email"
              dense
              outlined
              :error-messages="errorForField('email')"
              :rules="userRules.email"
              @input="resetError('email')"
            />
          </v-flex>
          <v-flex
            xs6
            md4
            px-2
          >
            <label class="cmr-label-text">Password (*)</label>
            <v-text-field
              v-model="user.password"
              :error-messages="errorForField('password')"
              :rules="!editingUser ? userRules.password : []"
              :append-icon="showPassword ? 'visibility' : 'visibility_off'"
              :type="showPassword ? 'text' : 'password'"
              outlined
              dense
              @input="resetError('password')"
              @click:append="showPassword = !showPassword"
            />
          </v-flex>
          <v-flex
            xs6
            md4
            px-2
          >
            <label class="cmr-label-text">Accounting Reference Number</label>
            <v-text-field
              outlined
              dense
              v-model="user.accounting_reference_number"
              :error-messages="errorForField('accounting_reference_number')"
              @input="resetError('accounting_reference_number')"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
export default {
  name: "UserFormV2",
  components: {},
  props: {
    user: Object,
    disabled: Boolean,
    editingUser: false,
    errors: { type: Object, default: () => {} },
  },
  data: function () {
    return {
      valid: false,
      showPassword: false,
      userRules: {
        name: [
          (v) => !!v || "Name is required",
          (v) => (v && v.length <= 100) || "Name cannot exceed 100 characters",
        ],
        email: [
          (v) => !!v || "Email is required",
          (v) => /.+@.+/.test(v) || "Email must be valid",
        ],
        contact_number: [(v) => !!v || "Mobile number is required"],
        password: [(v) => !!v || "Password is required"],
      },
    };
  },
  watch: {
    disabled: function () {
      this.$refs.userForm.reset();
    },
    valid: function () {
      this.$emit("validityChange", this.valid);
    },
  },
  methods: {
    errorForField: function (field) {
      try {
        return this.errors[field];
      } catch (err) {
        return null;
      }
    },
    resetError: function (field) {
      try {
        if (this.errors[field] != "") {
          this.errors[field] = "";
        }
      } catch (err) {}
    },
    validateForm: function () {
      this.$refs.userForm.validate();
    },
  },
};
</script>

<style>
.noStepNumber input[type="number"] {
  -moz-appearance: textfield;
}
.noStepNumber input::-webkit-outer-spin-button,
.noStepNumber input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>
